<template>
	<div style="display: contents">

		<v-icon large left v-if="step === 'search'">
			account_tree
		</v-icon>

		<v-btn
			v-if="step === 'unitary' || step === 'batch'"
			icon large
			class="mr-3"
			@click="$emit('search')">
			<v-icon large>arrow_back</v-icon>
		</v-btn>

		<h4 class="headline" v-if="step === 'search'">Choix du workflow</h4>

		<h4 class="headline" v-if="step === 'unitary' || step === 'batch'">
			{{ jd.label }}
			<v-btn v-if="is_admin"
				small icon class="ml-0"
				target="_blank"
				:href="`${maestro_url}jobs/versions/${jd.id}`">
				<v-icon>music_note</v-icon>
			</v-btn>
			<div class="caption" style="line-height: 16px">
				{{ jd.description }}
			</div>
			<div class="caption" style="line-height: 16px">
				{{ jd.version_description }}
			</div>
		</h4>

		<v-spacer />

		<v-btn
			v-if="step === 'search'"
			small depressed
			style="border: 1px solid"
			color="background darken-1 orange--text text--accent-3"
			class="ma-0 text-none"
			@click="$emit('open-old-launcher')">
			<v-icon class="mr-1">arrow_back</v-icon>
			Ancien launcher (déprécié)
		</v-btn>

		<v-btn icon large @click="$emit('close')">
			<v-icon large>close</v-icon>
		</v-btn>
	</div>
</template>

<script>
export default {
	props: [ 'step', 'jd' ],
	data () {
		return {
			is_admin: this.$user.isAdmin(),
			maestro_url: window.appConfig._$5u7vw2
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_v2_header.vue